var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ads_box',{attrs:{"ads_conf":_vm.get_ads('zjqp_banner')}}),_c('ads_box',{attrs:{"ads_conf":_vm.get_ads('99qp')}}),_c('ads_box',{attrs:{"ads_conf":_vm.get_ads('uu')}}),_c('ads_box',{attrs:{"ads_conf":_vm.get_ads('yl_plaer')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }